// Operations → Recommendations. §3.8.
//
// RELOCATION IS ADDITIVE (R1, R2, R3)
// ===================================
// "Relocate" in the migration map means the function appears in its new home. It
// never means the old one goes away. `RecommendationsDashboard` is rendered here,
// unmodified, and `/recommendations` continues to resolve to exactly what it
// resolved to before. Nothing moved on disk and nothing was deleted.
//
// The component is self-contained — it takes no props and owns its own fetching
// against /api/recommendations — so embedding it is the whole migration. Re-skinning
// it into the design system is a separate step and is not attempted here; doing it
// would mean editing a component this lane only reads.
//
// BUSINESS RECOMMENDATIONS ONLY
// =============================
// §3.8 is explicit that Cipher-about-Cipher recommendations stay in Brain →
// Pending Decisions. Nothing here filters for that, because the endpoint this
// component reads is the business one; the Cipher-about-Cipher set is a different
// surface that is not being built tonight and is not reached from here.
import React from "react";

import RecommendationsDashboard from "../../../components/RecommendationsDashboard";
import PageHead from "../../components/PageHead";

export default function Recommendations() {
  return (
    <>
      <PageHead
        title="Recommendations"
        subtitle="What Cipher suggests the business does next."
      />
      <RecommendationsDashboard />
    </>
  );
}
